import React, { createContext, useContext } from 'react'
//import { useLocalStorage } from '@uidotdev/usehooks' //FIXME: https://github.com/uidotdev/usehooks/issues/264
import { useLocalStorage } from 'usehooks-ts'

interface MachineContextType {
  cardPrinter: string
  setCardPrinter: any
  officePrinter: string
  setOfficePrinter: any
}

const MachineContext = createContext<MachineContextType>(
  {} as MachineContextType,
)
export const useMachineContext = () => useContext(MachineContext)

function CurrentMachine({ children }: { children: any }) {
  const [cardPrinter, setCardPrinter] = useLocalStorage('cardPrinter', '')
  const [officePrinter, setOfficePrinter] = useLocalStorage('officePrinter', '')

  return (
    <MachineContext.Provider
      value={{
        cardPrinter,
        setCardPrinter,
        officePrinter,
        setOfficePrinter,
      }}
    >
      {children}
    </MachineContext.Provider>
  )
}

export default CurrentMachine
